'use client';

import { getIsMobile } from '@/libs/utils/user';
import * as S from './styles';

const Content = () => {
  const isMobile = getIsMobile();
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const section2Title = isMobile
    ? '찾기 힘들었던 커뮤니티 속<br/><strong>맘카페, 지역 카페, 블로그리뷰</strong>도<br/> 놓치지 않아요'
    : '찾기 힘들었던 커뮤니티 속<br/><strong>맘카페, 지역 카페, 블로그리뷰</strong>도 놓치지 않아요';

  const contents = [
    {
      eyeBrowText: '통합 대시보드',
      title: '<strong>흩어진 리뷰</strong>를 한눈에<br/>리뷰 관리가 쉽고 간편해졌어요',
      highlightTextColor: 'linear-gradient(90deg, #3449ff 13%, #f86b3e 100%)',
      description: ['다양한 채널에서 수집된 리뷰를 체계적으로 관리', '대응이 필요한 악성리뷰와 미답변 리뷰를 손쉽게 확인'],
      image: {
        src: `${baseImageUrl}/landing/enterprise/dashboard${isMobile ? '-m-v1' : '-pc-v1'}.png`,
        alt: '통합 대시보드 화면',
        width: isMobile ? 270 : 800,
        height: isMobile ? 344 : 533
      }
    },
    {
      title: section2Title,
      highlightTextColor: '#F0501D',
      description: ['숨은 불만부터 좋은 후기까지 리얼한 리뷰 파악'],
      image: {
        src: `${baseImageUrl}/landing/enterprise/community${isMobile ? '-m' : ''}.png`,
        alt: '커뮤니티 리뷰 화면',
        width: isMobile ? 375 : 1054,
        height: isMobile ? 470 : 455
      }
    },
    {
      title: '매번 반복되는 리뷰 답변<br/><strong>리뷰웍스팀</strong>이 대신 관리해요',
      highlightTextColor: '#3449FF',
      description: isMobile ? ['병원 톤앤매너에 맞추어 리뷰 답변'] : ['24시간 이내 작성된 리뷰에 병원 톤앤매너에 맞춰 대신 답변'],
      image: {
        src: `${baseImageUrl}/landing/enterprise/reply${isMobile ? '-m-v1' : '-pc-v1'}.png`,
        alt: '고객 만족을 이끄는 맞춤 답글 화면',
        width: isMobile ? 375 : 1054,
        height: isMobile ? 424 : 455
      }
    },
    {
      title: '병원의 평판을 해치는 <strong>악성 리뷰</strong>는<br/>빠르게 탐지하고 해결해요',
      highlightTextColor: '#F0501D',
      description: ['병원 매출과 직결된 악성리뷰 즉각 삭제 요청 업무 대행'],
      image: {
        src: `${baseImageUrl}/landing/enterprise/malicious-review${isMobile ? '-m-v1' : '-pc-v1'}.png`,
        alt: '실시간 악성 리뷰 알림 화면',
        width: isMobile ? 343 : 1054,
        height: isMobile ? 612 : 455
      }
    },
    {
      title: '매달 한 번 발송되는<br/><strong>인사이트 리포트</strong>를 받아보세요',
      highlightTextColor: '#3449FF',
      description: ['병원 매출과 직결된 악성리뷰 즉각 삭제 요청 업무 대행'],
      image: {
        src: `${baseImageUrl}/landing/enterprise/analyze${isMobile ? '-m-v1' : '-pc-v1'}.png`,
        alt: '마케팅과 운영 활용을 위한 고객 인사이트 리포트 화면',
        width: isMobile ? 343 : 1054,
        height: isMobile ? 612 : 926
      }
    }
  ];

  return (
    <>
      {contents.map((content, index) => {
        const firstContent = index === 0;
        return (
          <S.Container key={`enterprise-content-container-${index}`}>
            <S.Inner firstContent={firstContent}>
              {firstContent && <S.EyeBrow>{content.eyeBrowText}</S.EyeBrow>}
              <S.SectionTitle color={content.highlightTextColor} dangerouslySetInnerHTML={{ __html: content.title }} />
              {content.description.map((text, descriptionIndex) => (
                <S.Description key={`enterprise-content-description-${index}${descriptionIndex}`}>{text}</S.Description>
              ))}
              <S.ImageBox firstContent={firstContent} backgroundColor={firstContent ? '#374151' : undefined}>
                <S.Img {...content.image} loading="eager" priority alt={content.image.alt} />
              </S.ImageBox>
            </S.Inner>
          </S.Container>
        );
      })}
    </>
  );
};

export default Content;
